module.exports = __webpack_public_path__ + "img/img_chongshenka1@2x.7cf64719.png";